import { Snack } from 'bc-front-sagacomponents';
import React, { useState } from 'react';
import Layout from '../../components/Layout';
import { isAuthenticated } from '../../services/Authentification/authentification';
import { useDemandeRemboursement } from './selectors';
import DemandeRemboursementContent from './Content';
import { Theme } from '@material-ui/core';
interface Props {}

const DemandeRemboursement = (props: Props) => {
  const { errorState, setError } = useDemandeRemboursement();
  const authenticated = isAuthenticated();

  const [theme, setTheme] = useState<Theme>();
  return (
    <Layout authenticated={authenticated} passTheme={setTheme}>
      {errorState && (
        <Snack
          message="Une erreur est survenue à l'affichage du document"
          type="error"
          onClose={() => setError(undefined)}
        />
      )}
      <DemandeRemboursementContent theme={theme}></DemandeRemboursementContent>
    </Layout>
  );
};
export default DemandeRemboursement;
